import React from 'react';

import '../css/postLayout.css';
import '../css/postDetail.css';
import { formatDate } from '../../../../format/formatDate';
import { useSeoPostDetail } from '../../../../seo/UseSeoPage';

const PostDetail = ({ data }) => {
  useSeoPostDetail(data);
  return data ? (
    <div className="bg-white shadow-lg mb-3 post-detail">
      <div className="card">
        <div className="card-body">
          <h1>{data.title}</h1>
        </div>
      </div>
      <div className="meta-icon mt-2">
        <div className="row">
          <div className="col-12 col-lg-9 ">
            <div className="author d-inline-flex me-3 ">
              <i className="fas fa-user"></i>
              <span className="ms-2">{data.author.full_name}</span>
            </div>
            <div className="update-time  d-inline-flex">
              <i className="fas fa-calendar-alt"></i>
              <span className="ms-2" id="update-time">
                {formatDate(data.created_at)}
              </span>
            </div>
          </div>
          <div className="col-12  col-lg-3 "> </div>
        </div>
      </div>

      <div className="d-flex article-detail flex-column flex-lg-row ">
        <div className="content" id="content">
          <article>
            {data?.content ? (
              <div dangerouslySetInnerHTML={{ __html: data?.content }} />
            ) : (
              <p>Không có nội dung.</p>
            )}
          </article>
        </div>
      </div>
    </div>
  ) : (
    <div className="bg-white shadow-lg mb-3 no-post">
      <p>Không có dữ liệu bài viết.</p>
    </div>
  );
};

export default PostDetail;
